<!--
	* 门店资质，首营新需求开发重构
	* xuzhongqi
	* 2020.12.29
	* update lt
	* 2021.09.07
 -->
<template>
  <iMineTemplate :page-title="pageTitle" :actived-parent-key="activedParentKey" :actived-key="activedKey">
    <template #rightContent>
      <!-- 页面主体 -->
      <div v-if="hasCache" class="flex-body">
        <!-- 门店资质信息，审核状态 组件 -->
        <Stores ref="Stores" :stores-data="storesData" />

        <!-- 基础信息表单 组件 -->
        <Information
          ref="Information"
          :is-sub-store="isSubStore"
          :define-data="defineData"
          :information-data="informationData"
          :has-name-phone="hasNamePhone"
          @on-trigger-change="queryChange"
        />

        <!-- 首营资料板块 -->
        <div class="flex-component">
          <div class="flex-title"><label>首营资料</label></div>

          <!-- 营业执照信息上传 组件 -->
          <License
            ref="License"
            :type-name="typeName"
            :business-nature-name="businessNatureName"
            :init-license-data="initLicenseData"
            :license-stale-day="licenseStaleDay"
          />
          <!-- 分割线 -->
          <el-divider />

          <!-- 食品经营许可证 -->
          <FoodBusinessLincense
            ref="FoodBusinessLincense"
            :init-food-business-lincense-data="initFoodBusinessLincenseData"
            :food-business-lincense-stale-day="foodBusinessLincenseStaleDay"
          />
          <!-- 分割线 -->
          <el-divider />

          <!-- 医疗机构执业许可证上传 组件 -->
          <div v-show="typeName !== null && typeName === 2">
            <Institution
              ref="Institution"
              :init-institution-data="initInstitutionData"
              :institution-stale-day="institutionStaleDay"
            />
            <!-- 分割线 -->
            <el-divider />
          </div>

          <!-- 药品经营许可证信息上传 组件 -->
          <div v-show="typeName !== null && typeName === 1 ">
            <BusinessLicense
              ref="BusinessLicense"
              :business-license-data="businessLicenseData"
              :business-stale-day="businessStaleDay"
              :business-gps-stale-day="businessGpsStaleDay"
            />
            <!-- 分割线 -->
            <el-divider />
          </div>

          <!-- 采购人员信息上传 组件 -->
          <Personnel
            ref="Personnel"
            :init-personnel-data="initPersonnelData"
            :personnel-stale-day="personnelStaleDay"
          />

          <!-- 第二类医疗器械经营备案凭证上传 组件 -->
          <div v-show="typeName !== null && typeName === 1">
            <!-- 分割线 -->
            <el-divider />
            <Record
              ref="Record"
              :type-name="typeName"
              :init-record-data="initRecordData"
              :record-stale-day="recordStaleDay"
            />
          </div>

          <!-- 提交 -->
          <div v-show="hasIsFirstOrder" class="submit">
            <el-button type="primary" @click="submit">提交审核</el-button>
          </div>
        </div>
      </div>
    </template>
  </iMineTemplate>
</template>
<script>
import { BaseMixin } from '../../mixins/BaseMixin.js'
// 门店资质信息组件
import Stores from './components/Stores/Stores.vue'
// 基础信息表单组件
import Information from './components/Information/Information.vue'
// 营业执照信息上传组件
import License from './components/License/License.vue'
// 药品经营许可证信息上传组件
import BusinessLicense from './components/BusinessLicense/BusinessLicense.vue'
// 采购人员信息上传组件
import Personnel from './components/Personnel/Personnel.vue'
// 第二类医疗器械经营备案凭证上传组件
import Record from './components/Record/Record.vue'
// 医疗机构执业许可证上传组件
import Institution from './components/Institution/Institution.vue'
// FoodBusinessLincense食品经营许可证
import FoodBusinessLincense from './components/FoodBusinessLincense/FoodBusinessLincense.vue'

export default {
  name: 'MyQualifications',
  components: {
    Stores,
    Information,
    License,
    BusinessLicense,
    Personnel,
    Record,
    Institution,
    FoodBusinessLincense
  },
  mixins: [BaseMixin],
  data() {
    return {
      // 面包屑配置
      pageTitle: ['我的账户', '门店资质'],
      activedParentKey: 1,
      activedKey: 13,
      // 组件缓存同步标记
      hasCache: false,
      // 客户类型标记参数
      typeName: null,
      // 诊所，营业执照，切换标记
      businessNatureName: null,
      // 状态组件参数
      storesData: {},
      // 联系人，手机号，是否能更改
      hasNamePhone: {},
      // 首营基础信组件参数
      informationData: {},
      // 首营基础信组件参数，深拷贝数据，用于提交时比对变化
      informationOriginal: {},
      // 首营基础信息自定义参数
      defineData: {},
      // 营业执照组件参数
      initLicenseData: {},
      // 营业执照组件有效期对象
      licenseStaleDay: {},
      // 采购人员组件参数
      initPersonnelData: {},
      // 采购人员有效期对象
      personnelStaleDay: {},
      // 第二类医疗器械经营备案凭证组件参数
      initRecordData: {},
      // 第二类医疗器械经营备案凭证有效期对象
      recordStaleDay: {},
      // 医疗机构执业许可证参数
      initInstitutionData: {},
      // 医疗机构执业许可证有效期对象
      institutionStaleDay: {},
      // 药品经营许可证参数
      businessLicenseData: {},
      // 药品经营许可证有效期对象
      businessStaleDay: {},
      // 药品经营许可证GPS有效期对象
      businessGpsStaleDay: {},
      // 用户是否可以提交首营标记
      hasIsFirstOrder: true,
      // 用户是否是子店
      isSubStore: false,
      // 资质数据深拷贝对象
      ZzInfosOriginal: {},
      PersonZzInfoOriginal: {},
      // 食品经营许可证有效期
      foodBusinessLincenseStaleDay: {},
      // 食品经营许可证参数
      initFoodBusinessLincenseData: {}
    }
  },
  mounted() {
    // 改变缓存状态
    this.hasCache = true
    // 获取当前用户的首营基本信息
    this.GetCustomerInfoZz()
    this.getIsSubStore()
  },
  methods: {
    /*
			 * 初始化获取用户状态，用于判断当前用户是否可以提交首营
			 */
    async getIsFirstOrder() {
      // 获取收货区域
      const res = await this.getAction(this.$comApi.IsFirstOrder)
      // 判断接口响应状态
      if (res.IsSuccess) {
        this.hasIsFirstOrder = res.Data
      } else {
        this.$message.error(res.Msg)
      }
    },
    /*
			 * 判断当前用户是否是主子门店的子店
			 */
    async getIsSubStore() {
      // 获取收货区域
      const res = await this.getAction('/api_customers/MutiCustomer/GetUserIsChildStore')
      // 判断接口响应状态
      if (res.IsSuccess) {
        this.isSubStore = res.Data
      } else {
        this.$message.error(res.Msg)
      }
    },
    /*
			 * 获取当前用户的首营基本信息
			 */
    async GetCustomerInfoZz() {
      // 获取收货区域
      const res = await this.getAction(this.$comApi.GetCustomerInfoZz)
      // 判断接口响应状态
      if (res.IsSuccess) {
        // 首营基本信息部分参数派发子组件
        this.informationData = {
          // CustomerId: res.Data.Id, //用户ID
          CustomerName: res.Data.CustomerName, // 机构名称
          CustomerType: res.Data.CustomerType, // 客户类型ID
          BusinessNature: res.Data.BusinessNature, // 经营性质
          Address: res.Data.Address, // 注册地址
          AreaId: res.Data.Area.Id, // 省市区ID
          // ReceivingAreaName: res.Data.Area.Province + res.Data.Area.City + res.Data.Area.County, //收获区域名称
          // ReceivingAddressName: res.Data.ReceivingAddressName, //详细地址
          ContactsName: res.Data.ContactsName, // 联系人姓名
          Phone: res.Data.Phone // 联系电话
        }
        this.typeName = res.Data.CustomerType === 1 ? (this.typeName = 1) : (this.typeName = 2)
        // operationState 添加操作状态权限 1新增，2编辑，3查看
        // cascaderDefuleTxt 省市区回显文本
        this.defineData = {
          cascaderDefuleTxt: res.Data.Area.Province + res.Data.Area.City + res.Data.Area.County,
          operationState: 2
        }
        // 数据变化,深拷贝一份数据
        this.informationOriginal = JSON.parse(JSON.stringify(this.informationData))
        // 获取当前用户的首营资质信息
        this.getQualifications(res.Data)
        // 初始化获取用户状态，用于判断当前用户是否可以提交首营
        this.getIsFirstOrder()
      } else {
        this.$message.error(res.Msg)
      }
    },
    /*
			 * 获取当前用户的首营资质信息
			 */
    async getQualifications(data) {
      // 获取收货区域
      const res = await this.getAction(this.$comApi.GetQualifications)
      // 判断接口响应状态
      if (res.IsSuccess) {
        // 拷贝数据，用于提交时比对
        this.ZzInfosOriginal = JSON.parse(JSON.stringify(res.Data.ZzInfos))
        this.PersonZzInfoOriginal = JSON.parse(JSON.stringify(res.Data.PersonZzInfo))

        // 营业执照参数派发
        // operationState 添加操作状态权限 1新增，2编辑，3查看
        const initLicenseData = JSON.stringify(res.Data)
        this.initLicenseData = {
          initLicenseData,
          data: data,
          operationState: 2
        }
        // 采购人员参数派发
        // operationState 添加操作状态权限 1新增，2编辑，3查看
        const initPersonnelData = JSON.stringify(res.Data)
        this.initPersonnelData = {
          initPersonnelData,
          operationState: 2
        }
        // 第二类医疗器械经营备案凭证参数派发
        // operationState 添加操作状态权限 1新增，2编辑，3查看
        const initRecordData = JSON.stringify(res.Data)
        this.initRecordData = {
          initRecordData,
          operationState: 2
        }
        // 食品经营许可证
        // operationState 添加操作状态权限 1新增，2编辑，3查看
        const initFoodBusinessLincenseData = JSON.stringify(res.Data)
        this.initFoodBusinessLincenseData = {
          initFoodBusinessLincenseData,
          operationState: 2
        }
        // 医疗机构执业许可证参数派发
        // operationState 添加操作状态权限 1新增，2编辑，3查看
        const initInstitutionData = JSON.stringify(res.Data)
        this.initInstitutionData = {
          initInstitutionData,
          operationState: 2
        }
        // 药品经营可证参数派发
        // operationState 添加操作状态权限 1新增，2编辑，3查看
        const businessLicenseData = JSON.stringify(res.Data)
        this.businessLicenseData = {
          businessLicenseData,
          operationState: 2
        }
        // 状态组件参数派发
        const storesData = JSON.stringify(res.Data)
        this.storesData = {
          storesData
        }
        // 联系人，手机号，是否能更改
        const hasNamePhone = JSON.stringify(res.Data)
        this.hasNamePhone = {
          hasNamePhone
        }
        // 处理有效性数据，匹配对应组件，并传递日期
        if (res.Data.StaleDateds && res.Data.StaleDateds.length !== 0) {
          res.Data.StaleDateds.forEach((value, index, array) => {
            if (value.LicenseName === '营业执照') {
              // 营业执照参数派发
              const licenseStaleDay = JSON.stringify(value)
              this.licenseStaleDay = {
                licenseStaleDay
              }
            }
            if (value.LicenseName === '医疗机构执业许可证') {
              // 医疗机构执业许可证参数派发
              const institutionStaleDay = JSON.stringify(value)
              this.institutionStaleDay = {
                institutionStaleDay
              }
            }
            if (value.LicenseName === '药品经营许可证') {
              // 药品经营许可证参数派发
              const businessStaleDay = JSON.stringify(value)
              this.businessStaleDay = {
                businessStaleDay
              }
            }
            if (value.LicenseName === 'GSP证书') {
              // GSP证书参数派发
              const businessGpsStaleDay = JSON.stringify(value)
              this.businessGpsStaleDay = {
                businessGpsStaleDay
              }
            }
            if (value.LicenseName === '采购人员') {
              // 采购人员参数派发
              const personnelStaleDay = JSON.stringify(value)
              this.personnelStaleDay = {
                personnelStaleDay
              }
            }
            if (value.LicenseName === '第二类医疗器械经营备案凭证') {
              // 第二类医疗器械经营备案凭证参数派发
              const recordStaleDay = JSON.stringify(value)
              this.recordStaleDay = {
                recordStaleDay
              }
            }
            if (value.LicenseName === '食品经营许可证') {
              // 食品经营许可证参数派发
              const foodBusinessLincenseStaleDay = JSON.stringify(value)
              this.foodBusinessLincenseStaleDay = {
                foodBusinessLincenseStaleDay
              }
            }
          })
        }
      } else {
        this.$message.error(res.Msg)
      }
    },
    /*
			 * 基础信息组件，客户类型筛选监听，经营性质筛选监听
			 */
    queryChange(e) {
      // 派发相关属性
      if (e.ContactsName !== '' && e.BusinessNature === '') {
        // 缓存子组件选择的客户类型，以供资质模块组件调用
        this.typeName = e.ContactsName
      }
      if (e.ContactsName === '' && e.BusinessNature !== '') {
        // 缓存子组件选择的经营性质，以供资质模块组件调用
        this.businessNatureName = e.BusinessNature
      }
    },
    /*
			 *  提交，参数拼装
			 */
    async submit() {
      // 验证 参数
      if (
        !this.$validation.informationForm(this.$refs.Information.information) ||
					!this.$validation.personnelForm(this.$refs.Personnel.personnel) ||
					!this.$validation.foodForm(this.$refs.FoodBusinessLincense.foodBusinessLincense)
      ) {
        return
      }

      // 验证 参数
      if (this.typeName === 1) {
        if (!this.$validation.recordForm(this.$refs.Record.record)) {
          return
        }
        if (!this.$validation.businessLicenseForm(this.$refs.BusinessLicense.businessLicense)) {
          return
        }
        if (!this.$validation.licenseForm(this.$refs.License.license)) {
          return
        }
      }

      // 验证 参数
      if (this.typeName === 2) {
        if (!this.$validation.institutionForm(this.$refs.Institution.institution)) {
          return
        }
        if (this.$refs.License.license.type === '1') {
          // 营利性，有营业执照
          if (!this.$validation.licenseForm(this.$refs.License.license)) {
            return
          }
        }
      }

      // 各类资质集合
      const ZzInfosArr = []
      if (this.$refs.Record.record.type === '1') {
        // 第二类医疗器械经营备案凭证
        ZzInfosArr.push({
          Xtype: 3, // 资质种类标记
          Name: this.$refs.Record.record.Name, // 证件名称
          ImgList: this.$refs.Record.record.ImgList, // 提交图片对象
          Time: this.$refs.Record.record.Time, // 有效期
          No: this.$refs.Record.record.No // 证件号
        })
      }

      // 药店
      if (this.typeName === 1) {
        // 营业执照
        ZzInfosArr.push({
          Xtype: 1, // 资质种类标记
          Name: this.$refs.License.license.Name, // 证件名称
          ImgList: this.$refs.License.license.ImgList, // 提交图片对象
          Time: this.$refs.License.license.Time, // 有效期
          No: this.$refs.License.license.No // 证件号
        })
      } else {
        // 判断是否有营业执照
        if (this.$refs.License.license.type === '1') {
          // 营业执照
          ZzInfosArr.push({
            Xtype: 1, // 资质种类标记
            Name: this.$refs.License.license.Name, // 证件名称
            ImgList: this.$refs.License.license.ImgList, // 提交图片对象
            Time: this.$refs.License.license.Time, // 有效期
            No: this.$refs.License.license.No // 证件号
          })
        }
      }

      // 判断是否有食品执照
      if (this.$refs.FoodBusinessLincense.foodBusinessLincense.type === '1') {
        // 食品执照
        ZzInfosArr.push({
          Xtype: 7, // 资质种类标记
          Name: this.$refs.FoodBusinessLincense.foodBusinessLincense.Name, // 证件名称
          ImgList: this.$refs.FoodBusinessLincense.foodBusinessLincense.ImgList, // 提交图片对象
          Time: this.$refs.FoodBusinessLincense.foodBusinessLincense.Time, // 有效期
          No: this.$refs.FoodBusinessLincense.foodBusinessLincense.No // 证件号
        })
      }

      if (this.typeName === 2) {
        // 医疗机构执业许可证
        ZzInfosArr.push({
          Xtype: 4, // 资质种类标记
          Name: this.$refs.Institution.institution.Name, // 证件名称
          ImgList: this.$refs.Institution.institution.ImgList, // 提交图片对象
          Time: this.$refs.Institution.institution.Time, // 有效期
          No: this.$refs.Institution.institution.No // 证件号
        })
      }

      if (this.typeName === 1) {
        // 药品经营许可证
        ZzInfosArr.push({
          Xtype: 2, // 资质种类标记
          Name: this.$refs.BusinessLicense.businessLicense.Name, // 证件名称
          ImgList: this.$refs.BusinessLicense.businessLicense.ImgList, // 提交图片对象
          Time: this.$refs.BusinessLicense.businessLicense.Time, // 有效期
          No: this.$refs.BusinessLicense.businessLicense.No // 证件号
        })
        if (this.$refs.BusinessLicense.businessLicense.type !== '1') {
          // GPS
          ZzInfosArr.push({
            Xtype: 5, // 资质种类标记
            Name: this.$refs.BusinessLicense.businessLicense.gpsName, // 证件名称
            ImgList: this.$refs.BusinessLicense.businessLicense.gpsImgList, // 提交图片对象
            Time: this.$refs.BusinessLicense.businessLicense.gpsTime, // 有效期
            No: this.$refs.BusinessLicense.businessLicense.gpsNo // 证件号
          })
        }
      }

      // 拼装提交对象
      let subJson = {}
      // 营业执照标记
      let HasBusinessLincense = null
      // 药店
      if (this.typeName === 1) {
        // 营业执照
        HasBusinessLincense = true
      } else {
        // 判断是否有营业执照
        if (this.$refs.License.license.type === '1') {
          // 营业执照
          HasBusinessLincense = true
        } else {
          HasBusinessLincense = false
        }
      }

      subJson = {
        // 基本信息数据
        ...this.$refs.Information.information,
        // 标记对象
        StateCenter: {
          IsHasFood: this.$refs.FoodBusinessLincense.foodBusinessLincense.type === '1', // 是否有食品证
          IsTwoInOne: this.$refs.BusinessLicense.businessLicense.type === '1', // 是否二证合一
          HasGSP: this.$refs.BusinessLicense.businessLicense.gpsType === '1', // 是否有GSP证书
          IsLegalPerson: this.$refs.Personnel.personnel.type === '1', // 是否法人
          HasBusinessLincense: HasBusinessLincense, // 是否有营业执照
          HasApparatus: this.typeName === 2, // 是否有医疗机构执业许可证
          HasSecondApparatus: this.$refs.Record.record.type === '1' // 是否有第二类医疗器械经营备案凭证
        },
        // 采购人员信息
        PersonZzInfo: {
          IsLegalPerson: this.$refs.Personnel.personnel.type === '1', // 是否法人
          Name: this.$refs.Personnel.personnel.Name, // 名称
          PersonName: this.$refs.Personnel.personnel.PersonName,
          IdCode: this.$refs.Personnel.personnel.IdCode,
          ImgList: this.$refs.Personnel.personnel.ImgList // 图片
        },
        // 各类资质集合
        ZzInfos: ZzInfosArr
      }

      // 比对新老数据，如果未修改，则不允许提交
      if (
        JSON.stringify(this.$refs.Information.information) === JSON.stringify(this.informationOriginal) &&
					JSON.stringify(ZzInfosArr) === JSON.stringify(this.ZzInfosOriginal) &&
					JSON.stringify(subJson.PersonZzInfo) === JSON.stringify(this.PersonZzInfoOriginal)
      ) {
        this.$message.warning('请更改信息后提交')
        return
      }

      // 调用接口，提交参数
      this.submitApi(subJson)
    },
    /*
			 *  提交，调用api
			 */
    async submitApi(data) {
      if (data) {
        const res = await this.putAction(this.$comApi.UpdateQualifications, data)
        if (res.IsSuccess) {
          this.$message.success('提交成功')
          // 更新页面数据
          this.clearData()
        } else {
          this.$message.error(res.Msg)
        }
      }
    },
    /*
			 *  更新页面数据
			 */
    async clearData() {
      // 改变缓存状态
      this.hasCache = false

      this.$nextTick(() => {
        // 改变缓存状态
        this.hasCache = true
        // 获取当前用户的首营基本信息
        this.GetCustomerInfoZz()
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .el-divider--horizontal {
    margin: 20px 0;
    background-color: #E8E8E8;
  }

  .submit {
    margin: 60px 0 20px;

    button {
      width: 190px;
      height: 50px;
      font-size: 16px;
      background-color: #0F6EEA;
    }
  }
</style>
